var map = {
	"./assets/fonts/fonts": 6592,
	"./assets/fonts/fonts.js": 6592,
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.eot": 39362,
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.ttf": 80673,
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.woff": 90360,
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.woff2": 93829,
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.eot": 88866,
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.ttf": 54537,
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.woff": 97073,
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.woff2": 63771,
	"./assets/fonts/tiempos-text/tiempos-text-web-regular-italic.eot": 18213,
	"./assets/fonts/tiempos-text/tiempos-text-web-regular-italic.woff": 1006,
	"./assets/fonts/tiempos-text/tiempos-text-web-regular-italic.woff2": 20210,
	"./assets/fonts/tiempos-text/tiempos-text-web-regular.eot": 41479,
	"./assets/fonts/tiempos-text/tiempos-text-web-regular.woff": 13298,
	"./assets/fonts/tiempos-text/tiempos-text-web-regular.woff2": 87748,
	"./assets/icons/bergTextLogo.svg": 13016,
	"./assets/icons/burgerIcon.svg": 25084,
	"./assets/icons/mastercard.svg": 64885,
	"./assets/icons/visa.svg": 45038,
	"./cache/analysts": 48613,
	"./cache/analysts.json": 48613,
	"./cache/categories": 65381,
	"./cache/categories.json": 65381,
	"./cache/footer": 36493,
	"./cache/footer.json": 36493,
	"./cache/header": 4230,
	"./cache/header.json": 4230,
	"./cache/images": 4565,
	"./cache/images.json": 4565,
	"./cache/pages": 65554,
	"./cache/pages.json": 65554,
	"./cache/posts": 57255,
	"./cache/posts.json": 57255,
	"./cache/productPanels": 70004,
	"./cache/productPanels.json": 70004,
	"./cache/products": 7628,
	"./cache/products.json": 7628,
	"./cache/sites": 41258,
	"./cache/sites.json": 41258,
	"./components/Account/AccountNav": 95740,
	"./components/Account/AccountNav.js": 95740,
	"./components/Account/AccountSettings": 71364,
	"./components/Account/AccountSettings.js": 71364,
	"./components/Account/AccountSettingsPopup": 57642,
	"./components/Account/AccountSettingsPopup.js": 57642,
	"./components/Account/CategoryFilters": 93322,
	"./components/Account/CategoryFilters.js": 93322,
	"./components/Account/ChangePassword": 23887,
	"./components/Account/ChangePassword.js": 23887,
	"./components/Account/DownloadButton": 79626,
	"./components/Account/DownloadButton.js": 79626,
	"./components/Account/MoreInfoPanel": 42881,
	"./components/Account/MoreInfoPanel.js": 42881,
	"./components/Account/MyReports": 56501,
	"./components/Account/MyReports.js": 56501,
	"./components/Account/ProfileView": 16374,
	"./components/Account/ProfileView.js": 16374,
	"./components/Account/ReportCard": 68887,
	"./components/Account/ReportCard.js": 68887,
	"./components/Account/ReportHeader": 25731,
	"./components/Account/ReportHeader.js": 25731,
	"./components/Account/ReportItem": 72282,
	"./components/Account/ReportItem.js": 72282,
	"./components/Account/ReportSearch": 21028,
	"./components/Account/ReportSearch.js": 21028,
	"./components/Account/SuccessfullySaved": 10158,
	"./components/Account/SuccessfullySaved.js": 10158,
	"./components/Analyst/AnalystCard": 99899,
	"./components/Analyst/AnalystCard.js": 99899,
	"./components/Analyst/AnalystPage": 7201,
	"./components/Analyst/AnalystPage.js": 7201,
	"./components/Analyst/FoldOutText": 72633,
	"./components/Analyst/FoldOutText.js": 72633,
	"./components/AspectWrapper": 83655,
	"./components/AspectWrapper.js": 83655,
	"./components/BackgroundImage": 51811,
	"./components/BackgroundImage.js": 51811,
	"./components/Breadcrumbs": 64793,
	"./components/Breadcrumbs/": 64793,
	"./components/Breadcrumbs/index": 64793,
	"./components/Breadcrumbs/index.js": 64793,
	"./components/Breakpoints": 34227,
	"./components/Breakpoints/": 34227,
	"./components/Breakpoints/breakpointValues": 3506,
	"./components/Breakpoints/breakpointValues.js": 3506,
	"./components/Breakpoints/breakpoints": 35010,
	"./components/Breakpoints/breakpoints.js": 35010,
	"./components/Breakpoints/index": 34227,
	"./components/Breakpoints/index.js": 34227,
	"./components/Button": 7004,
	"./components/Button.js": 7004,
	"./components/Cart/ProductListingHeading": 76006,
	"./components/Cart/ProductListingHeading.js": 76006,
	"./components/Category/CategoryHeading": 48501,
	"./components/Category/CategoryHeading.js": 48501,
	"./components/Category/EmptyProductCard": 12890,
	"./components/Category/EmptyProductCard.js": 12890,
	"./components/Checkout/Account": 50943,
	"./components/Checkout/Account.js": 50943,
	"./components/Checkout/AccountLogin": 34303,
	"./components/Checkout/AccountLogin.js": 34303,
	"./components/Checkout/AccountRegister": 81332,
	"./components/Checkout/AccountRegister.js": 81332,
	"./components/Checkout/BillingDetails": 92885,
	"./components/Checkout/BillingDetails.js": 92885,
	"./components/Checkout/Cart": 99239,
	"./components/Checkout/Cart.js": 99239,
	"./components/Checkout/LoginOrRegister": 88595,
	"./components/Checkout/LoginOrRegister.js": 88595,
	"./components/Checkout/PaymentMethod": 9573,
	"./components/Checkout/PaymentMethod.js": 9573,
	"./components/Checkout/Summary": 44970,
	"./components/Checkout/Summary.js": 44970,
	"./components/Checkout/data/countries": 49978,
	"./components/Checkout/data/countries.js": 49978,
	"./components/CookieConsent": 29420,
	"./components/CookieConsent/": 29420,
	"./components/CookieConsent/config": 79423,
	"./components/CookieConsent/config.js": 79423,
	"./components/CookieConsent/cookieconsent-overrides.css": 23722,
	"./components/CookieConsent/index": 29420,
	"./components/CookieConsent/index.js": 29420,
	"./components/ErrorCatcher": 62446,
	"./components/ErrorCatcher.js": 62446,
	"./components/Footer": 8638,
	"./components/Footer/": 8638,
	"./components/Footer/FooterSection": 17261,
	"./components/Footer/FooterSection.js": 17261,
	"./components/Footer/Newsletter": 5092,
	"./components/Footer/Newsletter.js": 5092,
	"./components/Footer/index": 8638,
	"./components/Footer/index.js": 8638,
	"./components/Grid": 54329,
	"./components/Grid.js": 54329,
	"./components/Header": 34469,
	"./components/Header/": 34469,
	"./components/Header/CartPopup": 27335,
	"./components/Header/CartPopup.js": 27335,
	"./components/Header/CartPopup/CartProductCard": 50848,
	"./components/Header/CartPopup/CartProductCard.js": 50848,
	"./components/Header/CartPopup/CartProductVariation": 17650,
	"./components/Header/CartPopup/CartProductVariation.js": 17650,
	"./components/Header/CartPopup/RemoveFromCartButton": 69062,
	"./components/Header/CartPopup/RemoveFromCartButton.js": 69062,
	"./components/Header/CheckoutHeader": 59279,
	"./components/Header/CheckoutHeader.js": 59279,
	"./components/Header/HeaderCart": 40611,
	"./components/Header/HeaderCart.js": 40611,
	"./components/Header/Navigation": 57823,
	"./components/Header/Navigation/": 57823,
	"./components/Header/Navigation/HeaderLink": 16708,
	"./components/Header/Navigation/HeaderLink.js": 16708,
	"./components/Header/Navigation/index": 57823,
	"./components/Header/Navigation/index.js": 57823,
	"./components/Header/index": 34469,
	"./components/Header/index.js": 34469,
	"./components/Heading": 46247,
	"./components/Heading.js": 46247,
	"./components/Hero/Hero404": 42286,
	"./components/Hero/Hero404.js": 42286,
	"./components/Hero/HeroAccount": 42065,
	"./components/Hero/HeroAccount.js": 42065,
	"./components/Hero/HeroModuleAbout": 29805,
	"./components/Hero/HeroModuleAbout.js": 29805,
	"./components/Hero/HeroModuleImage": 11970,
	"./components/Hero/HeroModuleImage.js": 11970,
	"./components/Hero/HeroModuleProduct": 72788,
	"./components/Hero/HeroModuleProduct.js": 72788,
	"./components/Hero/HeroModuleText": 91226,
	"./components/Hero/HeroModuleText.js": 91226,
	"./components/Hero/HeroThankYou": 50597,
	"./components/Hero/HeroThankYou.js": 50597,
	"./components/Image": 12802,
	"./components/Image.js": 12802,
	"./components/Link": 71811,
	"./components/Link/": 71811,
	"./components/Link/ArrowLink": 86321,
	"./components/Link/ArrowLink.js": 86321,
	"./components/Link/index": 71811,
	"./components/Link/index.js": 71811,
	"./components/LoadingIndicator": 59590,
	"./components/LoadingIndicator.js": 59590,
	"./components/ModuleHeader": 16128,
	"./components/ModuleHeader.js": 16128,
	"./components/News/NewsPostCard": 64182,
	"./components/News/NewsPostCard.js": 64182,
	"./components/Pagination": 3957,
	"./components/Pagination.js": 3957,
	"./components/ProductCard": 41897,
	"./components/ProductCard.js": 41897,
	"./components/ProductVariationsPicker": 41357,
	"./components/ProductVariationsPicker.js": 41357,
	"./components/Search": 44741,
	"./components/Search/": 44741,
	"./components/Search/Context/Search": 38202,
	"./components/Search/Context/Search.js": 38202,
	"./components/Search/HiddenSearchBox": 76658,
	"./components/Search/HiddenSearchBox.js": 76658,
	"./components/Search/SearchCategorySuggestions": 49900,
	"./components/Search/SearchCategorySuggestions.js": 49900,
	"./components/Search/SearchIndices": 88107,
	"./components/Search/SearchIndices.js": 88107,
	"./components/Search/SearchInfoText": 12438,
	"./components/Search/SearchInfoText.js": 12438,
	"./components/Search/SearchProductCard": 33366,
	"./components/Search/SearchProductCard.js": 33366,
	"./components/Search/SearchResult": 89821,
	"./components/Search/SearchResult.js": 89821,
	"./components/Search/SearchResultHeader": 73485,
	"./components/Search/SearchResultHeader.js": 73485,
	"./components/Search/index": 44741,
	"./components/Search/index.js": 44741,
	"./components/Seo": 87174,
	"./components/Seo/": 87174,
	"./components/Seo/index": 87174,
	"./components/Seo/index.js": 87174,
	"./components/Templates/404": 80553,
	"./components/Templates/404.js": 80553,
	"./components/Text": 62497,
	"./components/Text.js": 62497,
	"./components/ToggableText": 93250,
	"./components/ToggableText.js": 93250,
	"./components/Video/Video": 77682,
	"./components/Video/Video.js": 77682,
	"./components/WysiwygWrapper": 96946,
	"./components/WysiwygWrapper/": 96946,
	"./components/WysiwygWrapper/BlockQuote": 29618,
	"./components/WysiwygWrapper/BlockQuote.js": 29618,
	"./components/WysiwygWrapper/Bold": 46283,
	"./components/WysiwygWrapper/Bold.js": 46283,
	"./components/WysiwygWrapper/HeadingLevelFour": 72436,
	"./components/WysiwygWrapper/HeadingLevelFour.js": 72436,
	"./components/WysiwygWrapper/HeadingLevelThree": 49431,
	"./components/WysiwygWrapper/HeadingLevelThree.js": 49431,
	"./components/WysiwygWrapper/Italic": 80429,
	"./components/WysiwygWrapper/Italic.js": 80429,
	"./components/WysiwygWrapper/ListItem": 49385,
	"./components/WysiwygWrapper/ListItem.js": 49385,
	"./components/WysiwygWrapper/OrderedList": 72004,
	"./components/WysiwygWrapper/OrderedList.js": 72004,
	"./components/WysiwygWrapper/Underline": 5475,
	"./components/WysiwygWrapper/Underline.js": 5475,
	"./components/WysiwygWrapper/UnorderedList": 13459,
	"./components/WysiwygWrapper/UnorderedList.js": 13459,
	"./components/WysiwygWrapper/UnorderedListItem": 49728,
	"./components/WysiwygWrapper/UnorderedListItem.js": 49728,
	"./components/WysiwygWrapper/Url": 32013,
	"./components/WysiwygWrapper/Url.js": 32013,
	"./components/WysiwygWrapper/index": 96946,
	"./components/WysiwygWrapper/index.js": 96946,
	"./components/auth/Forgot": 50323,
	"./components/auth/Forgot.js": 50323,
	"./components/auth/Login": 28983,
	"./components/auth/Login.js": 28983,
	"./components/auth/Register": 41188,
	"./components/auth/Register.js": 41188,
	"./components/auth/Reset": 8732,
	"./components/auth/Reset.js": 8732,
	"./components/buttons/AddToCartButton": 61626,
	"./components/buttons/AddToCartButton.js": 61626,
	"./components/buttons/BurgerButton": 46792,
	"./components/buttons/BurgerButton.js": 46792,
	"./components/buttons/CheckboxButton": 34989,
	"./components/buttons/CheckboxButton.js": 34989,
	"./components/buttons/CrossButton": 14791,
	"./components/buttons/CrossButton.js": 14791,
	"./components/buttons/DownloadReportButton": 71874,
	"./components/buttons/DownloadReportButton.js": 71874,
	"./components/buttons/PlusMinusButton": 48311,
	"./components/buttons/PlusMinusButton.js": 48311,
	"./components/buttons/ProductCardButton": 92784,
	"./components/buttons/ProductCardButton.js": 92784,
	"./components/buttons/RadioButton": 89076,
	"./components/buttons/RadioButton.js": 89076,
	"./components/form/Input": 11067,
	"./components/form/Input.js": 11067,
	"./components/form/Select": 49853,
	"./components/form/Select.js": 49853,
	"./components/general/Error": 68543,
	"./components/general/Error.js": 68543,
	"./components/global/mediaqueries": 70115,
	"./components/global/mediaqueries.js": 70115,
	"./components/layout": 37198,
	"./components/layout.js": 37198,
	"./components/pages/SearchResultsPage": 92705,
	"./components/pages/SearchResultsPage.js": 92705,
	"./components/pages/account": 95013,
	"./components/pages/account.js": 95013,
	"./components/pages/forgot-password": 79181,
	"./components/pages/forgot-password.js": 79181,
	"./components/pages/login": 38015,
	"./components/pages/login.js": 38015,
	"./components/pages/register": 93550,
	"./components/pages/register.js": 93550,
	"./components/pages/reset-password": 87545,
	"./components/pages/reset-password.js": 87545,
	"./components/post/BigPostCard": 54365,
	"./components/post/BigPostCard.js": 54365,
	"./components/post/BigPostText": 75753,
	"./components/post/BigPostText.js": 75753,
	"./components/post/PostCard": 24480,
	"./components/post/PostCard.js": 24480,
	"./components/product/formatProductDate": 32875,
	"./components/product/formatProductDate.js": 32875,
	"./components/product/highlight/ProductHighlightList": 91433,
	"./components/product/highlight/ProductHighlightList.js": 91433,
	"./components/product/highlight/ProductHighlightSection": 49628,
	"./components/product/highlight/ProductHighlightSection.js": 49628,
	"./components/product/highlight/ProductHighlightText": 53076,
	"./components/product/highlight/ProductHighlightText.js": 53076,
	"./components/productGallery/Interactable": 8306,
	"./components/productGallery/Interactable.js": 8306,
	"./components/productGallery/ProductGallery": 10410,
	"./components/productGallery/ProductGallery.js": 10410,
	"./components/productGallery/ProductGalleryButton": 55493,
	"./components/productGallery/ProductGalleryButton.js": 55493,
	"./components/productInfo/ProductInfo": 41960,
	"./components/productInfo/ProductInfo.js": 41960,
	"./components/productInfo/ProductInfoPopup": 41664,
	"./components/productInfo/ProductInfoPopup.js": 41664,
	"./components/productInfo/ProductInfoTableOfContents": 84630,
	"./components/productInfo/ProductInfoTableOfContents.js": 84630,
	"./components/tracking/DataLayer": 80860,
	"./components/tracking/DataLayer.js": 80860,
	"./components/typography/Tag": 66936,
	"./components/typography/Tag.js": 66936,
	"./components/typography/TextNumber": 38802,
	"./components/typography/TextNumber.js": 38802,
	"./components/user/AccountDetails": 15024,
	"./components/user/AccountDetails.js": 15024,
	"./components/user/ReportList": 22062,
	"./components/user/ReportList.js": 22062,
	"./components/utils/AuthRoute": 12335,
	"./components/utils/AuthRoute.js": 12335,
	"./components/utils/supportsPassiveEvents": 89067,
	"./components/utils/supportsPassiveEvents.js": 89067,
	"./containers/WysiwygContainer": 28001,
	"./containers/WysiwygContainer.js": 28001,
	"./helpers/auth-header": 72881,
	"./helpers/auth-header.js": 72881,
	"./hooks/useAuth": 10352,
	"./hooks/useAuth.js": 10352,
	"./hooks/useProductCategories": 56793,
	"./hooks/useProductCategories.js": 56793,
	"./hooks/useProductPanel": 95077,
	"./hooks/useProductPanel.js": 95077,
	"./hooks/useProductPermalinkLookup": 71844,
	"./hooks/useProductPermalinkLookup.js": 71844,
	"./hooks/useReportSearchIds": 31567,
	"./hooks/useReportSearchIds.js": 31567,
	"./html": 90230,
	"./html.js": 90230,
	"./icons/Arrow": 63936,
	"./icons/Arrow.js": 63936,
	"./icons/BergStar": 68490,
	"./icons/BergStar.js": 68490,
	"./icons/Download": 7638,
	"./icons/Download.js": 7638,
	"./icons/LinkedIn": 82096,
	"./icons/LinkedIn.js": 82096,
	"./icons/MyPageIcon": 34935,
	"./icons/MyPageIcon.js": 34935,
	"./icons/SearchIcon": 79822,
	"./icons/SearchIcon.js": 79822,
	"./icons/Spinner": 49597,
	"./icons/Spinner.js": 49597,
	"./icons/base/Circle": 87856,
	"./icons/base/Circle.js": 87856,
	"./icons/base/Group": 54664,
	"./icons/base/Group.js": 54664,
	"./icons/base/Line": 5020,
	"./icons/base/Line.js": 5020,
	"./icons/base/Path": 60092,
	"./icons/base/Path.js": 60092,
	"./icons/base/SVG": 56502,
	"./icons/base/SVG.js": 56502,
	"./icons/leftCursor.svg": 63733,
	"./icons/rightCursor.svg": 86517,
	"./images/404.jpg": 51331,
	"./images/ThankYou.jpg": 65338,
	"./images/gatsby-astronaut.png": 19697,
	"./images/gatsby-icon.png": 54396,
	"./images/login-background.jpg": 81729,
	"./libs/BergCommerceAPI/Basket/AddToCart": 98039,
	"./libs/BergCommerceAPI/Basket/AddToCart.js": 98039,
	"./libs/BergCommerceAPI/Basket/Context/Cart": 56981,
	"./libs/BergCommerceAPI/Basket/Context/Cart.js": 56981,
	"./libs/BergCommerceAPI/Basket/Cookies": 46105,
	"./libs/BergCommerceAPI/Basket/Cookies.js": 46105,
	"./libs/BergCommerceAPI/Basket/GenerateBasketKey": 29559,
	"./libs/BergCommerceAPI/Basket/GenerateBasketKey.js": 29559,
	"./libs/BergCommerceAPI/Basket/GetBasket": 92159,
	"./libs/BergCommerceAPI/Basket/GetBasket.js": 92159,
	"./libs/BergCommerceAPI/Basket/ItemCount": 31194,
	"./libs/BergCommerceAPI/Basket/ItemCount.js": 31194,
	"./libs/BergCommerceAPI/Basket/RemoveFromCart": 75186,
	"./libs/BergCommerceAPI/Basket/RemoveFromCart.js": 75186,
	"./libs/BergCommerceAPI/Basket/getCheckoutHref": 53589,
	"./libs/BergCommerceAPI/Basket/getCheckoutHref.js": 53589,
	"./libs/BergCommerceAPI/util": 5869,
	"./libs/BergCommerceAPI/util/": 5869,
	"./libs/BergCommerceAPI/util/buildQueryString": 90024,
	"./libs/BergCommerceAPI/util/buildQueryString.js": 90024,
	"./libs/BergCommerceAPI/util/fetch": 14302,
	"./libs/BergCommerceAPI/util/fetch.js": 14302,
	"./libs/BergCommerceAPI/util/fetch.spec": 8893,
	"./libs/BergCommerceAPI/util/fetch.spec.js": 8893,
	"./libs/BergCommerceAPI/util/index": 5869,
	"./libs/BergCommerceAPI/util/index.js": 5869,
	"./libs/scroll": 30814,
	"./libs/scroll.js": 30814,
	"./load-module": 84345,
	"./load-module.js": 84345,
	"./modules/Analysts": 35998,
	"./modules/Analysts/": 35998,
	"./modules/Analysts/index": 35998,
	"./modules/Analysts/index.js": 35998,
	"./modules/Content": 56293,
	"./modules/Content/": 56293,
	"./modules/Content/index": 56293,
	"./modules/Content/index.js": 56293,
	"./modules/Faq": 12691,
	"./modules/Faq/": 12691,
	"./modules/Faq/FaqItem": 88146,
	"./modules/Faq/FaqItem.js": 88146,
	"./modules/Faq/index": 12691,
	"./modules/Faq/index.js": 12691,
	"./modules/Header/Article": 95310,
	"./modules/Header/Article.js": 95310,
	"./modules/Header/ArticleText": 78659,
	"./modules/Header/ArticleText.js": 78659,
	"./modules/Header/LinksReport": 45716,
	"./modules/Header/LinksReport.js": 45716,
	"./modules/Header/VerticalHeading": 38598,
	"./modules/Header/VerticalHeading.js": 38598,
	"./modules/Link": 12948,
	"./modules/Link/": 12948,
	"./modules/Link/index": 12948,
	"./modules/Link/index.js": 12948,
	"./modules/NewsListing": 48512,
	"./modules/NewsListing/": 48512,
	"./modules/NewsListing/index": 48512,
	"./modules/NewsListing/index.js": 48512,
	"./modules/NotFound": 81932,
	"./modules/NotFound/": 81932,
	"./modules/NotFound/index": 81932,
	"./modules/NotFound/index.js": 81932,
	"./modules/OneSectionPosts": 53891,
	"./modules/OneSectionPosts/": 53891,
	"./modules/OneSectionPosts/index": 53891,
	"./modules/OneSectionPosts/index.js": 53891,
	"./modules/PostModules/ImageSection": 85739,
	"./modules/PostModules/ImageSection.js": 85739,
	"./modules/PostModules/TextSection": 82227,
	"./modules/PostModules/TextSection.js": 82227,
	"./modules/Posts": 41047,
	"./modules/Posts/": 41047,
	"./modules/Posts/index": 41047,
	"./modules/Posts/index.js": 41047,
	"./modules/Products": 6754,
	"./modules/Products/": 6754,
	"./modules/Products/index": 6754,
	"./modules/Products/index.js": 6754,
	"./modules/Quote": 23939,
	"./modules/Quote/": 23939,
	"./modules/Quote/index": 23939,
	"./modules/Quote/index.js": 23939,
	"./modules/Reference": 4450,
	"./modules/Reference/": 4450,
	"./modules/Reference/index": 4450,
	"./modules/Reference/index.js": 4450,
	"./modules/References": 13602,
	"./modules/References/": 13602,
	"./modules/References/index": 13602,
	"./modules/References/index.js": 13602,
	"./modules/SinglePost": 67850,
	"./modules/SinglePost/": 67850,
	"./modules/SinglePost/index": 67850,
	"./modules/SinglePost/index.js": 67850,
	"./modules/SingleProduct": 42453,
	"./modules/SingleProduct/": 42453,
	"./modules/SingleProduct/index": 42453,
	"./modules/SingleProduct/index.js": 42453,
	"./modules/Text": 72303,
	"./modules/Text/": 72303,
	"./modules/Text/index": 72303,
	"./modules/Text/index.js": 72303,
	"./modules/TextImage": 59261,
	"./modules/TextImage/": 59261,
	"./modules/TextImage/index": 59261,
	"./modules/TextImage/index.js": 59261,
	"./styles/main.css": 14348,
	"./styles/theme": 25130,
	"./styles/theme.js": 25130,
	"./templates": 6772,
	"./templates/": 6772,
	"./templates/MainTemplate": 13871,
	"./templates/MainTemplate.js": 13871,
	"./templates/ThankYou": 40616,
	"./templates/ThankYou.js": 40616,
	"./templates/analyst": 92551,
	"./templates/analyst.js": 92551,
	"./templates/category": 24098,
	"./templates/category.js": 24098,
	"./templates/checkout": 20141,
	"./templates/checkout.js": 20141,
	"./templates/index": 6772,
	"./templates/index.js": 6772,
	"./templates/page": 74755,
	"./templates/page.js": 74755,
	"./templates/post": 19857,
	"./templates/post.js": 19857,
	"./templates/product": 90111,
	"./templates/product.js": 90111,
	"./utils/algolia-queries": 18073,
	"./utils/algolia-queries.js": 18073,
	"./utils/checkRequiredFields": 3442,
	"./utils/checkRequiredFields.js": 3442,
	"./utils/dynamicScaling": 10692,
	"./utils/dynamicScaling.js": 10692,
	"./utils/formatDate": 36854,
	"./utils/formatDate.js": 36854,
	"./utils/formatPrice": 26244,
	"./utils/formatPrice.js": 26244,
	"./utils/getToken": 5001,
	"./utils/getToken.js": 5001,
	"./utils/getUserData": 85701,
	"./utils/getUserData.js": 85701,
	"./utils/getWindowSize": 61160,
	"./utils/getWindowSize.js": 61160,
	"./utils/htmlDecode": 23362,
	"./utils/htmlDecode.js": 23362,
	"./utils/inBrowser": 35948,
	"./utils/inBrowser.js": 35948,
	"./utils/isLoggedIn": 35230,
	"./utils/isLoggedIn.js": 35230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 31279;
module.exports = webpackContext;